import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LearningModeSelector.css';

function LearningModeSelector({ topic, learningPath, onMentorMode }) {
    const navigate = useNavigate();

    const modes = [
        {
            id: 'study',
            icon: '📚',
            title: 'Study Mode',
            description: 'Read and learn at your own pace. Work through lessons and practice questions.',
            color: '#667eea',
            gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            action: () => {
                // Scroll down to the learning path modules
                document.querySelector('.skill-tree')?.scrollIntoView({ behavior: 'smooth' });
            },
            buttonText: 'Start Studying'
        },
        {
            id: 'adventure',
            icon: '🗺️',
            title: 'Adventure Mode',
            description: 'Learn through games! Complete lessons to unlock 7 mini-games at each checkpoint.',
            color: '#f59e0b',
            gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
            action: () => {
                navigate('/world-map', {
                    state: { topic }
                });
            },
            buttonText: 'Start Adventure'
        },
        {
            id: 'mentor',
            icon: '🎓',
            title: 'AI Mentor Mode',
            description: 'Your personal AI tutor. Listen to lectures and ask questions with "Hey Viva".',
            color: '#10b981',
            gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
            premium: true,
            action: () => {
                if (onMentorMode) {
                    onMentorMode();
                }
            },
            buttonText: 'Start Mentoring'
        }
    ];

    return (
        <div className="learning-mode-selector">
            <div className="mode-selector-header">
                <h2>Choose Your Learning Style</h2>
                <p>Three ways to master {topic}</p>
            </div>

            <div className="mode-cards">
                {modes.map(mode => (
                    <div
                        key={mode.id}
                        className={`mode-card ${mode.id}`}
                        style={{ '--mode-color': mode.color, '--mode-gradient': mode.gradient }}
                    >
                        {mode.premium && (
                            <div className="premium-badge">PREMIUM</div>
                        )}
                        <div className="mode-icon">{mode.icon}</div>
                        <h3 className="mode-title">{mode.title}</h3>
                        <p className="mode-description">{mode.description}</p>
                        <button
                            className="mode-button"
                            onClick={mode.action}
                        >
                            {mode.buttonText}
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default LearningModeSelector;
